export type AppContext = 'platform' | 'admin' | 'entry';

/**
 * Detects the current application context based on the hostname or path.
 * - platform: Platform Provider (Vendor) Admin
 * - admin: Partner (Tenant/University) Admin
 * - entry: Student (Examinee/Enrollment) Screen
 */
export function detectAppContext(): AppContext {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  // Domain-based detection (Online)
  if (hostname.includes('admission-platform')) return 'platform';
  if (hostname.includes('admission-admin')) return 'admin';
  if (hostname.includes('admission-entry')) return 'entry';

  // Path-based detection (Local/Dev)
  if (pathname.startsWith('/platform') || pathname.startsWith('/system')) return 'platform';
  if (pathname.startsWith('/entry')) return 'entry';

  // Default to admin for local development if no other matches
  return 'admin';
}
